import {useSocket} from "../../../helpers/socket";
import Live2KPWrapper from "./Live2KPWrapper";

const MainKPWrapper = ({config}) => {
    const {socket} = useSocket({platform: `kp_website`})
    return <Live2KPWrapper socket={socket} config={config}/>
}

export default MainKPWrapper;